import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
export var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    color: theme.palette.text.primary,
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(14),
    maxWidth: 600,
    margin: 'auto',
    overflow: 'hidden',
    WebkitLineClamp: 6,
    WebkitBoxOrient: 'vertical'
  }, theme.breakpoints.up('sm'), {
    WebkitLineClamp: 4
  });
});
//# sourceMappingURL=styles.js.map